import type { LexicalNode } from "lexical";
import { $isParagraphNode } from "lexical";
import { $isHeadingNode } from "@lexical/rich-text";
import { $isListItemNode } from "@lexical/list";
import { $isTableCellNode, $isTableNode } from "@lexical/table";
import { $isImageBlockNode } from "../nodes/ImageBlockNode";

export function findClosestBlockNodeKey(node: LexicalNode | null | undefined): string | null {
  let cur: LexicalNode | null | undefined = node;
  while (cur) {
    // 列表场景要把 block 锚点锁定在 listitem，而不是其内部 paragraph
    if ($isListItemNode(cur)) return cur.getKey();
    if ($isImageBlockNode(cur)) return cur.getKey();
    if ($isTableNode(cur)) return cur.getKey();
    if ($isParagraphNode(cur)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const parent = (cur as any).getParent?.() ?? null;
      if ($isListItemNode(parent)) {
        cur = parent;
        continue;
      }
      if ($isTableCellNode(parent)) {
        cur = parent;
        continue;
      }
      return cur.getKey();
    }
    if ($isHeadingNode(cur)) return cur.getKey();
    // ElementNode 有 getParent；LeafNode 也可以通过 getParent() 向上找到块容器
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cur = (cur as any).getParent?.() ?? null;
  }
  return null;
}

